import { render } from "./B2bFiltersServicios.vue?vue&type=template&id=74b5b963&scoped=true&lang=pug"
import script from "./B2bFiltersServicios.vue?vue&type=script&lang=js"
export * from "./B2bFiltersServicios.vue?vue&type=script&lang=js"

import "./B2bFiltersServicios.vue?vue&type=style&index=0&id=74b5b963&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b5b963"]])

export default __exports__